export default "__VITE_ASSET__CSg6Rdmp__"